const prvaDiagnozaIzjava = {
    potrjujemPrejemDokumentov: {
        name: 'potrjujemPrejemDokumentov',
        type: 'checkbox',
        formType: 'checkbox-required-checked',
        required: true,
        value: false,
        text: {
            sl: 'Vseh zgoraj navedenih dokumetov',
        },
    },
    datumPodpisa: {
        name: 'datumPodpisa',
        type: 'xs:dateTime',
        formType: 'auto-date-time-now',
        required: true,
        value: undefined,
    },
    podpisZavarovalec: {
        name: 'podpisZavarovalec',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis zavarovalca',
        },
    },
    podpisZavarovanec: {
        name: 'podpisZavarovanec',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis zavarovanca',
        },
    },
    podpisSvetovalec: {
        name: 'podpisSvetovalec',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis svetovalca',
        },
    },
};

module.exports = { prvaDiagnozaIzjava };